import { configureStore } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";
import { combineReducers } from "redux";


import rootSaga from "./rootSaga";
import { loadState, saveState } from "./config/sessionPersist";
import { authReducer } from "./Login/login.reducers";
import employeeFlowReducer from "./EmployeeFlow/employeeFlow.reducers";
import hospitalManagementReducer from "./HospitalManagement/hospitalManagement.reducers";
const sagaMiddleware = createSagaMiddleware();

// Combine all reducers
const rootReducer = combineReducers({
  auth: authReducer,
  employeeFlow:employeeFlowReducer,
    hospitalManagement:hospitalManagementReducer
  // add other reducers here
});

// Load persisted state from localStorage
const preloadedState = loadState();

// Configure store
export const store = configureStore({
  reducer: rootReducer,
  preloadedState,
  middleware: (gdm) => gdm({ serializableCheck: false }).concat(sagaMiddleware),
});

// Run Sagas
sagaMiddleware.run(rootSaga);

// Persist only necessary slices (auth + employeeFlow)
store.subscribe(() => {
  saveState({
    auth: store.getState().auth,
    employeeFlow: store.getState().employeeFlow,
  });
});
